export class DeactivateAtlasOrganizationResponse {
    'atlasOrganization';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "atlasOrganization",
            "baseName": "atlasOrganization",
            "type": "AtlasOrganization",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DeactivateAtlasOrganizationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
